<template>
    <div>
        <el-dialog
            :visible.sync="isTip"
            width="40%"
            :before-close="handleClose">
            <!-- <span style="position:absolute;right:40px;top:20px">关闭窗口</span> -->
            <div v-if="isApp=='0'"><img src="../assets/images/xx.png" alt="" class="audioImg"></div>
            <div v-else><img src="../assets/images/yinpintanchuang.png" alt="" class="audioImg"></div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name:'AudioTip',
    data(){
        return{}
    },
    methods:{
        handleClose() {
           this.$emit('hideMe')             
        },
    },
    props:['isTip','isApp']   
}
</script>

<style scoped>
    .audioImg{
        width: 100%;
    }
    >>>.el-dialog__header{
        padding: 0;
    }
    >>> .el-dialog__body{
        padding: 0;
    }
    >>>.el-dialog{
        background: none;
        -weblit-box-shadow:none;
        box-shadow:none;
    }
     /* >>>.el-dialog__headerbtn { top: 8px !important; background: url(../assets/images/xx.png); background-size: cover; }
     >>>.el-dialog__headerbtn i { content: '修改下面的font-size可以改变图片的大小'; font-size: 25px; visibility: hidden; } */
</style>


// WEBPACK FOOTER //
// src/components/AudioTip.vue